import type { Environment } from './environment.interface';

/** Environnement de test / recette (QA). */
export const environment: Environment = {
  production: false,
  apiUrl: 'https://test-api.cmine.example.com/api',
  name: 'test',
  mock: false,
};
